export default "__VITE_ASSET__75LmTy8m__"